import axios from "axios";
import {API_BASE_URL} from "../constants/api";
import {ACCESS_TOKEN} from "../constants/auth";

const MicroQualificationService = {};

MicroQualificationService.getMicroQualificationById = async function (id) {
    return axios({
        method: "get",
        url: API_BASE_URL + `/api/editor/microqualification/get/${id}`,
        headers: {
            "Content-Type": "application/json",
            'Authorization': `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`
        }
    });
}

MicroQualificationService.getMicroqualifications = async function (page, limit, role, id) {
    const params = {
        page: page - 1,
        limit: limit
    };

    if (role === 'editor') {
        params.moderatorId = id
    }

    let api = `/api/${role}/microqualification/get`;

    if (role === 'director') {
        api = `/api/admin/microqualification/get/director`;
    }

    const response = await axios({
        method: "get",
        url: API_BASE_URL + api,
        params,
        headers: {
            "Content-Type": "application/json",
            'Authorization': `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
        }
    });
    const data = response.data.list;
    const hasMore = response.data.hasMore;
    return {data, hasMore};
}

MicroQualificationService.saveMicroqualification = async function (nameRu, nameKz, nameEng, id) {
    return axios({
        method: "post",
        url: API_BASE_URL + `/api/editor/microqualification/save`,
        params: {
            nameRu: nameRu,
            nameKz: nameKz,
            nameEng: nameEng,
            id: id
        },
        headers: {
            "Content-Type": "application/json",
            'Authorization': `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
        }
    });
}

MicroQualificationService.saveFirstStepData = async function (id, licenceNumber, creditNum, levelOfNQF, isAccreditationExist, learnLanguageRu, learnLanguageKz, learnLanguageEng, isLearnOffline, isLearnOnline, isLearnMixed, professionalStandards) {
    return axios({
        method: "post",
        url: API_BASE_URL + `/api/editor/microqualification/${id}/update/general`,
        data: {
            licenceNumber: licenceNumber,
            creditNumbers: creditNum,
            levelOfNQF: levelOfNQF,
            isAccreditationExist: isAccreditationExist,
            learnLanguageEng: learnLanguageEng,
            learnLanguageRu: learnLanguageRu,
            learnLanguageKz: learnLanguageKz,
            isLearnMixed: isLearnMixed,
            isLearnOnline: isLearnOnline,
            isLearnOffline: isLearnOffline,
            professionalStandards: professionalStandards || []
        },
        headers: {
            "Content-Type": "application/json",
            'Authorization': `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
        }
    });
}

MicroQualificationService.saveSecondStepData = async function (id, educationField, trainingDirection, groupEP, partnerOrg, mainDirectionRu, mainDirectionKz, mainDirectionEng, goalRu, goalKz, goalEng) {
    let data = new FormData();
    data.append("educationField", educationField);
    data.append("trainingDirection", trainingDirection);
    data.append("groupEP", groupEP);
    data.append("partnerOrg", partnerOrg);
    data.append("mainDirectionRu", mainDirectionRu);
    data.append("mainDirectionKz", mainDirectionKz);
    data.append("mainDirectionEng", mainDirectionEng);
    data.append("goalRu", goalRu);
    data.append("goalKz", goalKz);
    data.append("goalEng", goalEng);

    return axios({
        method: "post",
        url: API_BASE_URL + `/api/editor/microqualification/${id}/update/main`,
        data,
        headers: {
            "Content-Type": "application/json",
            'Authorization': `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
        }
    });
}

MicroQualificationService.saveThirdStepData = async function (id, opTasks) {
    return axios({
        method: "post",
        url: API_BASE_URL + `/api/editor/microqualification/${id}/update/tasks`,
        data: opTasks,
        headers: {
            "Content-Type": "application/json",
            'Authorization': `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
        }
    });
}

MicroQualificationService.saveFourthStepFirstData = async function (id, opDescOfCandORu, opDescOfCandOKz, opDescOfCandOEng) {
    return axios({
        method: "post",
        url: API_BASE_URL + `/api/editor/microqualification/${id}/update/competence`,
        params: {
            opDescOfCandORu: opDescOfCandORu,
            opDescOfCandOKz: opDescOfCandOKz,
            opDescOfCandOEng: opDescOfCandOEng
        },
        headers: {
            "Content-Type": "application/json",
            'Authorization': `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
        }
    });
}

MicroQualificationService.saveFourthStepSecondData = async function (id, competences) {
    return axios({
        method: "post",
        url: API_BASE_URL + `/api/editor/microqualification/${id}/update/competences`,
        data: competences,
        headers: {
            "Content-Type": "application/json",
            'Authorization': `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
        }
    });
}

MicroQualificationService.saveFifthStepData = async function (id, results) {
    return axios({
        method: "post",
        url: API_BASE_URL + `/api/editor/microqualification/${id}/update/results`,
        data: results,
        headers: {
            "Content-Type": "application/json",
            'Authorization': `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
        }
    });
}

MicroQualificationService.saveSixStepData = async function (id, results) {
    return axios({
        method: "post",
        url: API_BASE_URL + `/api/editor/microqualification/${id}/update/results/competences`,
        data: results,
        headers: {
            "Content-Type": "application/json",
            'Authorization': `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
        }
    });
}

MicroQualificationService.saveSevenStepData = async function (id, opDisciplines) {
    return axios({
        method: "post",
        url: API_BASE_URL + `/api/editor/microqualification/${id}/update/disciplines`,
        data: opDisciplines,
        headers: {
            "Content-Type": "application/json",
            'Authorization': `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
        }
    });
}

MicroQualificationService.saveEightStepData = async function (id, opAuthors) {
    return axios({
        method: "post",
        url: API_BASE_URL + `/api/editor/microqualification/${id}/update/authors`,
        data: opAuthors,
        headers: {
            "Content-Type": "application/json",
            'Authorization': `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
        }
    });
}

MicroQualificationService.getEducationFields = async function (page, limit) {
    const response = await axios({
        method: "get",
        url: API_BASE_URL + `/api/editor/microqualification/get/education-fields`,
        params: {
            page: page - 1,
            limit: limit
        },
        headers: {
            "Content-Type": "application/json",
            'Authorization': `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
        }
    });
    const data = response.data.list;
    const hasMore = response.data.hasMore;
    return {data, hasMore};
}

MicroQualificationService.saveEducationField = async function (nameRu, nameKz, nameEng, code) {
    return axios({
        method: "post",
        url: API_BASE_URL + `/api/admin/education-field/save`,
        params: {
            nameRu: nameRu,
            nameKz: nameKz,
            nameEng: nameEng,
            code: code
        },
        headers: {
            "Content-Type": "application/json",
            'Authorization': `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
        }
    });
}

MicroQualificationService.importEducationFieldsByExcel = async function (file) {
    let data = new FormData();
    data.append("file", file);

    return axios({
        method: "post",
        url: API_BASE_URL + `/api/admin/education-field/import`,
        data: data,
        headers: {
            "Content-Type": "application/form-data",
            'Authorization': `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
        }
    });
}

MicroQualificationService.getTrainingDirections = async function (page, limit, id) {
    const response = await axios({
        method: "get",
        url: API_BASE_URL + `/api/editor/microqualification/get/training-directions`,
        params: {
            page: page - 1,
            limit: limit,
            id: id !== undefined ? id : null,
        },
        headers: {
            "Content-Type": "application/json",
            'Authorization': `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
        }
    });
    const data = response.data.list;
    const hasMore = response.data.hasMore;
    return {data, hasMore};
}

MicroQualificationService.saveTrainingDirection = async function (nameRu, nameKz, nameEng, code, fieldId) {
    return axios({
        method: "post",
        url: API_BASE_URL + `/api/admin/training-direction/save`,
        params: {
            nameRu: nameRu,
            nameKz: nameKz,
            nameEng: nameEng,
            code: code,
            fieldId: fieldId
        },
        headers: {
            "Content-Type": "application/json",
            'Authorization': `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
        }
    });
}

MicroQualificationService.importTrainingDirectionsByExcel = async function (file) {
    let data = new FormData();
    data.append("file", file);

    return axios({
        method: "post",
        url: API_BASE_URL + `/api/admin/training-direction/import`,
        data: data,
        headers: {
            "Content-Type": "application/form-data",
            'Authorization': `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
        }
    });
}

MicroQualificationService.getEducationProgramsGroup = async function (page, limit, id) {
    const response = await axios({
        method: "get",
        url: API_BASE_URL + `/api/editor/microqualification/get/group-eps`,
        params: {
            page: page - 1,
            limit: limit,
            id: id !== undefined ? id : null
        },
        headers: {
            "Content-Type": "application/json",
            'Authorization': `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
        }
    });
    const data = response.data.list;
    const hasMore = response.data.hasMore;
    return {data, hasMore};
}

MicroQualificationService.saveEducationProgramsGroup = async function (nameRu, nameKz, nameEng, code, id) {
    return axios({
        method: "post",
        url: API_BASE_URL + `/api/admin/group-ep/save`,
        params: {
            nameRu: nameRu,
            nameKz: nameKz,
            nameEng: nameEng,
            code: code,
            directionId: id
        },
        headers: {
            "Content-Type": "application/json",
            'Authorization': `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
        }
    });
}

MicroQualificationService.importEducationGroupProgramsByExcel = async function (file) {
    let data = new FormData();
    data.append("file", file);

    return axios({
        method: "post",
        url: API_BASE_URL + `/api/admin/group-ep/import`,
        data: data,
        headers: {
            "Content-Type": "application/form-data",
            'Authorization': `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
        }
    });
}

MicroQualificationService.getPartnerOrganizations = async function (page, limit) {

    const response = await axios({
        method: "get",
        url: API_BASE_URL + `/api/editor/microqualification/get/partner-orgs`,
        params: {
            page: page - 1,
            limit: limit
        },
        headers: {
            "Content-Type": "application/json",
            'Authorization': `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
        }
    });
    const data = response.data.list;
    const hasMore = response.data.hasMore;
    return {data, hasMore};
}

MicroQualificationService.savePartnerOrganization = async function (nameRu, nameKz, nameEng, image, firstName, lastName, middleName, firstNameEng, lastNameEng, positionRu, positionKz, positionEng, workPlaceRu, workPlaceKz, workPlaceEng) {
    let data = new FormData();
    data.append("nameRu", nameRu);
    data.append("nameKz", nameKz);
    data.append("nameEng", nameEng);
    data.append("image", image);
    data.append("firstName", firstName);
    data.append("lastName", lastName);
    if (middleName !== undefined) {
        data.append("middleName", middleName);
    }
    data.append("firstNameEng", firstNameEng);
    data.append("lastNameEng", lastNameEng);
    data.append("positionRu", positionRu);
    data.append("positionKz", positionKz);
    data.append("positionEng", positionEng);
    data.append("workPlaceRu", workPlaceRu);
    data.append("workPlaceKz", workPlaceKz);
    data.append("workPlaceEng", workPlaceEng);

    return axios({
        method: "post",
        url: API_BASE_URL + `/api/admin/partner-organization/save`,
        data: data,
        headers: {
            "Content-Type": "multipart/form-data",
            'Authorization': `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
        }
    });
}

MicroQualificationService.importPartnerOrganizationsByExcel = async function (file) {
    let data = new FormData();
    data.append("file", file);

    return axios({
        method: "post",
        url: API_BASE_URL + `/api/admin/partner-organization/import`,
        data: data,
        headers: {
            "Content-Type": "application/form-data",
            'Authorization': `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
        }
    });
}

MicroQualificationService.getProfessionalStandards = async function (page, limit) {

    const response = await axios({
        method: "get",
        url: API_BASE_URL + `/api/editor/microqualification/get/prof-standards`,
        params: {
            page: page - 1,
            limit: limit
        },
        headers: {
            "Content-Type": "application/json",
            'Authorization': `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
        }
    });
    const data = response.data.list;
    const hasMore = response.data.hasMore;
    return {data, hasMore};
}

MicroQualificationService.saveProfessionalStandard = async function (nameRu, nameKz, nameEng, code, date) {
    return axios({
        method: "post",
        url: API_BASE_URL + `/api/admin/prof-standard/save`,
        params: {
            nameRu: nameRu,
            nameKz: nameKz,
            nameEng: nameEng,
            code: code,
            date: date
        },
        headers: {
            "Content-Type": "application/json",
            'Authorization': `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
        }
    });
}

MicroQualificationService.importProfessionalStandardsByExcel = async function (file) {
    let data = new FormData();
    data.append("file", file);

    return axios({
        method: "post",
        url: API_BASE_URL + `/api/admin/prof-standard/import`,
        data: data,
        headers: {
            "Content-Type": "application/form-data",
            'Authorization': `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
        }
    });
}

MicroQualificationService.getAuthors = async function (page, limit) {

    const response = await axios({
        method: "get",
        url: API_BASE_URL + `/api/admin/microqualification/get/authors`,
        params: {
            page: page - 1,
            limit: limit
        },
        headers: {
            "Content-Type": "application/json",
            'Authorization': `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
        }
    });
    const data = response.data.list;
    const hasMore = response.data.hasMore;
    return {data, hasMore};
}

MicroQualificationService.getResource = async function (id) {
    return axios({
        method: "get",
        url: API_BASE_URL + `/api/admin/microqualification/get/resource/${id}`,
        responseType: "blob",
        headers: {
            "Content-Type": "application/json",
            'Authorization': `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
        }
    });
}

MicroQualificationService.sendToCheck = async function (id) {
    let data = new FormData();
    data.append("id", id);

    return axios({
        method: "post",
        url: API_BASE_URL + "/api/editor/microqualification/check",
        data: data,
        headers: {
            "Content-Type": "multipart/form-data",
            'Authorization': `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
        }
    });
}

MicroQualificationService.sendBackToModerator = async function (id) {
    let data = new FormData();
    data.append("id", id);

    return axios({
        method: "post",
        url: API_BASE_URL + "/api/admin/microqualification/reject",
        data: data,
        headers: {
            "Content-Type": "multipart/form-data",
            'Authorization': `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
        }
    });
}

MicroQualificationService.approveMicroqualifation = async function (id) {
    let data = new FormData();
    data.append("id", id);

    return axios({
        method: "post",
        url: API_BASE_URL + "/api/admin/microqualification/approve",
        data: data,
        headers: {
            "Content-Type": "multipart/form-data",
            'Authorization': `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
        }
    });
}
MicroQualificationService.commentMicroqualifation = async function (comment, id) {
    let data = new FormData();
    data.append("id", id);
    data.append("comment", comment);

    return axios({
        method: "post",
        url: API_BASE_URL + "/api/admin/microqualification/comment",
        data: data,
        headers: {
            "Content-Type": "multipart/form-data",
            'Authorization': `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
        }
    });
}

MicroQualificationService.registerMicroqualification = async function (regNumber, regDate, id) {
    return axios({
        method: "post",
        url: API_BASE_URL + `/api/admin/microqualification/register`,
        params: {
            id: id,
            regNumber: regNumber,
            regDate: regDate,
        },
        headers: {
            "Content-Type": "application/json",
            'Authorization': `Bearer ${localStorage.getItem(ACCESS_TOKEN)}`,
        }
    });
}


export default MicroQualificationService;
